module.exports = __webpack_public_path__ + "static/media/stockhausen_cats_4.0fd886fe.jpg";